__turbopack_context__.v({
  "colored": "PartnerLogo-module-scss-module__eWyaea__colored",
  "container": "PartnerLogo-module-scss-module__eWyaea__container",
  "neutral": "PartnerLogo-module-scss-module__eWyaea__neutral",
  "tooltip": "PartnerLogo-module-scss-module__eWyaea__tooltip",
  "visible": "PartnerLogo-module-scss-module__eWyaea__visible",
});
